import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../../environments/environment';

/**
 * Makes non-production environments impossible to mistake for the real site.
 *
 * Staging is an optimised build of the same code on the same domain family, so
 * without a marker it looks identical to production — which is exactly how
 * people end up testing against live data by accident.
 *
 * Renders nothing at all in production.
 */
@Component({
  selector: 'app-env-banner',
  standalone: true,
  template: `
    @if (show) {
      <!-- Hairline strip across the very top. Costs 4px of height and is
           visible on every screen without covering anything. -->
      <div class="env-strip" aria-hidden="true"></div>

      <!-- Corner tag. pointer-events:none so it can never block a click on
           whatever sits underneath it. -->
      <div class="env-tag" role="status" [attr.aria-label]="'Environment: ' + envName">
        <span class="env-tag__dot" aria-hidden="true"></span>
        <span class="env-tag__name">{{ envName }}</span>
        <span class="env-tag__project">{{ projectId }}</span>
      </div>
    }
  `,
  styleUrls: ['./env-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnvBannerComponent {
  private document = inject(DOCUMENT);

  readonly envName = environment.envName;
  readonly projectId = environment.firebase.projectId;
  readonly show = !environment.production;

  constructor() {
    if (!this.show) return;

    // The tab title is the one marker that survives a screenshot, a bookmark
    // and a window full of tabs.
    this.document.title = `[${this.envName}] ${this.document.title}`;
  }
}
